import { combineReducers } from "redux";
import contact from "../features/admin/contactform/contact/Slice";

const contactform = combineReducers({
  contact: contact,
});

export default contactform;
